import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PaymentIntegrationComponent} from './payment-integration.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [PaymentIntegrationComponent],
  exports: [PaymentIntegrationComponent]
})
export class PaymentIntegrationModule {
}



// WEBPACK FOOTER //
// ./src/app/components/payment-integration/payment-integration.module.ts